// dndManager.js
import { createDragDropManager } from "dnd-core";
import { HTML5Backend } from "react-dnd-html5-backend";

// Created once, never recreated — survives component remounts
const dndManager = createDragDropManager(HTML5Backend);

export default dndManager;
